var map = {
	"./binance.svg": "11b1",
	"./bitfinex.svg": "8766",
	"./bitmex.svg": "284e",
	"./bittrex.svg": "5da4",
	"./coinbase.svg": "3aaf",
	"./gateio.svg": "702d",
	"./hitbtc.svg": "f4f6",
	"./huobipro.svg": "eaa1",
	"./kraken.svg": "e127",
	"./okex.svg": "d1c9",
	"./poloniex.svg": "c2e9",
	"./upbit.svg": "9b4b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e7a";